import * as Yup from "yup";

export const customerInitialValues = {
  name: "",
  email: "",
  phone: "",
  dni: "",
  address: {
    line1: "",
    line2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
  },
};

export const customerValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone is required"),
  dni: Yup.string().required("DNI is required"),
  address: Yup.object().shape({
    line1: Yup.string().required("Address Line 1 is required"),
    line2: Yup.string(),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    postalCode: Yup.string().required("Postal Code is required"),
    country: Yup.string().required("Country is required"),
  }),
});
